export const CAREER_PATH = "/career";
